import { currentUserOrganizationListKeys } from '@repo/query-keys/user';
import { useQuery } from '@tanstack/react-query';
import { getCurrentUserOrganizationList } from 'ze-sdk';
export const currentUserOrganizationList = {
    available: {
        queryKey: currentUserOrganizationListKeys.available.queryKey,
        queryFn: async ()=>{
            const { entities } = await getCurrentUserOrganizationList();
            return entities;
        }
    }
};
export function useCurrentUserOrganizationList() {
    const { data, error, isLoading } = useQuery(currentUserOrganizationList.available);
    return {
        organizationList: data,
        isLoading,
        error
    };
}
